export const CATEGORIES = [
    {
        title: "Animation",
        icon: "animation",
        description:
            "Learn the latest animation techniques to create stunning motion design and captivate your audience.",
        link: "#",
    },

    {
        title: "Design",
        icon: "design",
        description:
            "Create beautiful, usable interfaces to help shape the future of how the web looks",
        link: "#",
    },
    {
        title: "Photography",
        icon: "photography",
        description:
            "Explore critical fundamentals like lighting, composition, and focus to capture exceptional photos",
        link: "#",
    },
    {
        title: "Crypto",
        icon: "crypto",
        description:
            "All you need to know to get started investing in crypto. Go from beginner to advanced with this 54 hour course",
        link: "#",
    },
    {
        title: "Business",
        icon: "business",
        description:
            "A step-by-step playbook to help you start, scale, and sustain your business without outside investment",
        link: "#",
    },
];
